import { Field, Form as FormikForm, Formik } from 'formik';
import moment from 'moment';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dimmer, Form, Grid, Header, Loader } from 'semantic-ui-react';
import { FormikDateComponent } from '../../../utilities/formUtils';
import TransTypeToRlbOptions from '../../reports/components/transTypeRlbSelect';
import { fetchDownloadData } from '../data/actions';
import { downloaddata } from '../data/model';
import * as select from '../data/selectors';
import ReportOptions from './reportOption';


const DownloadDataForm = (props) => {
    const downloadDataFetched = useSelector(state => select.getIsDownloadDataFetched(state, props))
    const dispatch = useDispatch()
    const date = new Date()
    const todayDate = moment(date).format("YYYY-MM-DD")

    const downloadData = (values, resetForm) => {
        if(values.report_name === "trans_date"){
            values.trans_type = ""
        }
        dispatch(fetchDownloadData(values))
    }
    
    return (
        <div>
            {downloadDataFetched === 'pending' &&
                <Dimmer active>
                    <Loader indeterminate>Preparing Files</Loader>
                </Dimmer>
            }
            <Grid columns={3} divided>
                <Grid.Row>
                    <Grid.Column style={{ margin: 'auto' }}>
                        <Header style={{ textAlign: 'center', padding: '30px 0' }} as='h1'>Download Data</Header>
                        <Formik id="downloadDataForm" size="large" width={5}
                            initialValues={downloaddata()}
                            onSubmit={(values, { resetForm }) => downloadData(values, resetForm)}
                            render={({ handleSubmit, onChange, values, handleChange, setFieldValue }) => (
                                <Form as={FormikForm} size="small" className="CustomeForm" width={5} onSubmit={handleSubmit}>
                                    <ReportOptions name="report_name" placeholder="Report Option " isTxn={false} label="Report Option " isSelection={true} />
                                    {values.report_name === "created_date" ? 
                                    <TransTypeToRlbOptions name="trans_type" setFieldValue={setFieldValue} width={5} isTxn={false} label="Select Trans Type" isSelection={true} />
                                    : null}
                                    <Field label="From Date" setFieldValueM={todayDate} name="from_date" component={FormikDateComponent} placeholder="dd-mm-yyyy"></Field>
                                    <Field label="To Date" setFieldValueM={todayDate} name="to_date" component={FormikDateComponent} placeholder="dd-mm-yyyy"></Field>
                                    <div style={{ textAlign: 'center' }}>
                                        <Button type="submit" size="medium" color='blue' className="CustomeBTN"> Download Data</Button>
                                    </div>
                                </Form>
                            )}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </div>
    )
};

export default DownloadDataForm;